import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes} from '@angular/router'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import './prototypes'
import { DbService } from './services/db.service'
import { LangService } from './services/lang.service'

import { MatExpansionModule } from '@angular/material/expansion'
import { MatInputModule } from '@angular/material'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatRadioModule } from '@angular/material/radio'

import { DxToastModule, DxCheckBoxModule, DxTextBoxModule, DxButtonModule, DxSliderModule, DxTextAreaModule, DxNumberBoxModule, DxPopupModule } from 'devextreme-angular'

import { NgbModule } from '@ng-bootstrap/ng-bootstrap'

import { DeviceDetectorModule } from 'ngx-device-detector'

import { AppComponent } from './app.component';
import { BookingComponent } from './components/booking/booking.component';
import { PayComponent } from './components/pay/pay.component';
import { MyBookingComponent } from './components/my-booking/my-booking.component';
import { CancelComponent } from './components/cancel/cancel.component';
import { MinToTimePipe } from './pipes/min-to-time.pipe';
import { BookingEventComponent } from './components/booking-event/booking-event.component';
import { BookingRestComponent } from './components/booking-rest/booking-rest.component';
import { BookingGridComponent } from './components/booking-grid/booking-grid.component';
import { TimelinePipe } from './pipes/timeline.pipe';
import { ResFilterPipe } from './pipes/res-filter.pipe';
import { SlotFilterPipe } from './pipes/slot-filter.pipe';
import { CatimgPipe } from './pipes/catimg.pipe';
import { SplitposPipe } from './pipes/splitpos.pipe';
import { CatPipe } from './pipes/cat.pipe';
import { BokningsbartPipe } from './pipes/bokningsbart.pipe';
import { LangPipe } from './pipes/lang.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslateBeginningPipe } from './pipes/translate-beginning.pipe';
import { TranslateSplitPipe } from './pipes/translate-split.pipe';
import { TranslateWordsPipe } from './pipes/translate-words.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { RefPipe } from './pipes/ref.pipe';
import { AutoSlotFilterPipe } from './pipes/auto-slot-filter.pipe';
import { ShiftFilterPipe } from './pipes/shift-filter.pipe';

const appRoutes:Routes = [
  {
    path: '',
    component: BookingComponent
  },
  {
    path: 'bokning',
    component: BookingComponent
  },
  {
    path: 'bokning/:system',
    component: BookingComponent
  },
  {
    path: 'bokning/:system/:resource',
    component: BookingComponent
  },
  {
    path: 'minbokning/:system/:workday/:id',
    component: MyBookingComponent
  },
  {
    path: 'minasidor/:system/:mobil',
    component: MyBookingComponent
  },
  {
    path: 'avbokning/:system/:id',
    component: CancelComponent
  },
  {
    path: 'betala/:system/:id',
    component: PayComponent
  },
  {
    path: 'avbokning',
    component: CancelComponent
  }
]

@NgModule({
  declarations: [
    AppComponent,
    BookingComponent,
    PayComponent,
    MyBookingComponent,
    CancelComponent,
    MinToTimePipe,
    BookingEventComponent,
    BookingRestComponent,
    BookingGridComponent,
    TimelinePipe,
    ResFilterPipe,
    SlotFilterPipe,
    CatimgPipe,
    SplitposPipe,
    CatPipe,
    BokningsbartPipe,
    LangPipe,
    TranslatePipe,
    TranslateBeginningPipe,
    TranslateSplitPipe,
    TranslateWordsPipe,
    SanitizeHtmlPipe,
    RefPipe,
    AutoSlotFilterPipe,
    ShiftFilterPipe
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    NgbModule.forRoot(),
    MatInputModule, MatButtonModule, MatCheckboxModule, MatRadioModule,
    DxToastModule, DxCheckBoxModule, DxTextBoxModule, DxButtonModule,
    DxSliderModule, DxTextAreaModule, DxNumberBoxModule, DxPopupModule,
    DeviceDetectorModule.forRoot()
  ],
  providers: [DbService, LangService],
  bootstrap: [AppComponent]
})
export class AppModule { }
